export default __webpack_public_path__ + "static/media/social-communities.e64989ee.svg";